import { Link } from "react-router-dom";
import { getHotMovies, movies } from "@/lib/media";
import { categories } from "@/mocks/site";

const hotTags = ["悬疑推理", "科幻巨制", "治愈日常", "国风动画", "高分手作", "年度黑马", "年代剧", "音乐综艺"];

export default function HomeSidebar() {
  const ranking = getHotMovies(6);

  return (
    <aside className="space-y-6" aria-label="侧边栏">
      <section className="card-surface overflow-hidden">
        <div className="flex items-center justify-between border-b border-background-200 bg-primary-500 px-4 py-3">
          <h2 className="flex items-center gap-2 font-heading text-sm font-semibold text-background-50">
            <i className="ri-bar-chart-box-line" aria-hidden="true" />
            热播榜 TOP 6
          </h2>
          <span className="text-[10px] uppercase tracking-wider text-primary-200">Daily</span>
        </div>
        <ol className="px-4 py-2">
          {ranking.map((movie, index) => (
            <li key={movie.id} className="border-b border-background-100 last:border-b-0">
              <Link to={`/detail/${movie.id}`} className="group flex items-center gap-3 py-3">
                <span
                  className={`w-5 shrink-0 font-heading text-base font-bold ${
                    index < 3 ? "text-accent-600" : "text-foreground-300"
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
                    {movie.title}
                  </p>
                  <p className="mt-0.5 truncate text-xs text-foreground-400">
                    {movie.genres.slice(0, 2).join(" / ")} · {movie.year}
                  </p>
                </div>
                <span className="shrink-0 font-heading text-sm font-semibold text-primary-700">
                  {movie.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section className="card-surface p-4">
        <h2 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
          <i className="ri-price-tag-3-line text-accent-500" aria-hidden="true" />
          热门标签
        </h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-md border border-background-200 bg-background-100 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:border-accent-300 hover:bg-accent-50 hover:text-accent-700"
            >
              {tag}
            </Link>
          ))}
        </div>
      </section>

      <section className="card-surface p-4">
        <h2 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
          <i className="ri-folder-2-line text-primary-600" aria-hidden="true" />
          分类导航
        </h2>
        <div className="mt-3 space-y-2">
          {categories.map((category) => {
            const count = movies.filter((item) => item.type === category.key).length;
            return (
              <Link
                key={category.key}
                to={`/category/${category.key}`}
                className="flex items-center justify-between rounded-md border border-background-200 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-background-100 hover:text-primary-700"
              >
                <span className="flex items-center gap-2">
                  <i className={`${category.icon} text-base text-accent-500`} aria-hidden="true" />
                  {category.name}
                </span>
                <span className="font-heading text-xs text-foreground-400">{count} 部</span>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="rounded-lg bg-primary-500 p-5 text-background-50">
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-accent-300">
          <i className="ri-sparkling-2-line" aria-hidden="true" />
          Weekly pick
        </p>
        <h2 className="mt-2 font-heading text-lg font-bold">本周编辑私藏</h2>
        <p className="mt-2 text-xs leading-6 text-primary-100">
          五部不够热门但足够好看的作品，包含一部被低估的英剧和一部只有十二话的治愈动画。
        </p>
        <Link
          to="/search?q=治愈"
          className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3 py-1.5 text-xs font-semibold text-primary-950 transition-colors hover:bg-accent-400"
        >
          立即查看
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </section>
    </aside>
  );
}